export default "__VITE_ASSET__AFpHUcO5__"